import {Component, OnDestroy, OnInit} from '@angular/core';
import {CartService} from '../../shopping-cart/cart.service';
import {
  CartDownloadInfo,
  CartDownloadInfoWithLineItems,
  DownloadInfoWithLineItem,
  DownloadService,
} from '../../shopping-cart/download.service';
import {Observable, of, Subscription, zip} from 'rxjs';
import {first, map, mergeMap} from 'rxjs/operators';
import {UserService} from '@uofu-uss-aux/software-catalog-ng-core';
import {NotificationService} from '@uofu-uss/angular-util';
import {sortBy} from 'lodash-es';
import {RouterLink} from '@angular/router';
import {DownloadListComponent} from '../download-list/download-list.component';

@Component({
  selector: 'app-available-downloads',
  templateUrl: './available-downloads.component.html',
  styleUrls: ['./available-downloads.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    DownloadListComponent
  ]
})
export class AvailableDownloadsComponent implements OnInit, OnDestroy {

  public itemsAvailable = false;
  public initialized = false;
  public items?: readonly DownloadInfoWithLineItem[];

  private _subscription: Subscription;

  constructor(private readonly cartService: CartService,
              private readonly userService: UserService,
              private readonly notificationService: NotificationService,
              private readonly downloadService: DownloadService) {
  }

  ngOnInit(): void {
    const unid = this.userService.value.unid;
    const observer = {
      next: this.loadSuccess,
      error: this.loadError,
    };
    this._subscription = this.downloadService.fetchAvailableByUnid(unid)
      .pipe(
        mergeMap((downloads) => this.withLineItems(downloads)),
        first())
      .subscribe(observer);
  }

  private withLineItems(downloads: readonly CartDownloadInfo[]): Observable<ReadonlyArray<CartDownloadInfoWithLineItems>> {
    if (!downloads || !downloads.length) {
      return of([]);
    }
    const mapped = downloads.map(download => {
      return this.cartService.fetchLineItems(download.cart)
        .pipe(map(lineItems => this.downloadService.combineCartDownloadsWithLineItem(lineItems, download)));
    });
    return zip(...mapped);
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  readonly loadError = (e) => {
    this.items = [];
    this.initialized = true;
    this.notificationService.addError('Unable to fetch available downloads');
  }

  readonly loadSuccess = (cartDownloads: ReadonlyArray<CartDownloadInfoWithLineItems>) => {
    this.initialized = true;
    this.itemsAvailable = !!cartDownloads.length;
    this.items = this.itemsAvailable ? this.downloadService.reduceToUniqueList(cartDownloads) : [];
    this.items = this.sort(this.items);
  }

  sort(downloads: readonly DownloadInfoWithLineItem[]): readonly DownloadInfoWithLineItem[] {
    return sortBy(downloads, (d) => d.lineItem.product.title);
  }

}
